import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Share2, Video, Package, Trophy } from "lucide-react";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";

const LABELS = { en_attente_paiement: "Attente paiement", recue: "Reçue", en_preparation: "En préparation", en_livraison: "En livraison", livree: "Livrée" };

const SECTIONS = [
  { key: "orders", label: "Mes commandes", icon: Package },
  { key: "candidacies", label: "Mes candidatures", icon: Trophy },
];

export default function ClientDashboard({ user }) {
  const [tab, setTab] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
    api.get("/candidates/mine").then((r) => setCandidates(r.data)).catch(() => {});
  }, []);

  const copyLink = (slug) => {
    const url = `${window.location.origin}/candidat/${slug}`;
    navigator.clipboard.writeText(`Votez pour moi aux Élections 2027 COCARDE Pizza ! ${url} #cocardepizza`);
    toast.success("Lien de candidat copié !");
  };

  return (
    <DashboardLayout title="Mon espace" subtitle={`Bonjour ${user?.name || ""}`} sections={SECTIONS} active={tab} onSelect={setTab}>
      {tab === "orders" && (
        <div>
          <h2 className="font-display text-2xl cc-navy flex items-center gap-2 mb-4"><Package size={22} /> Mes commandes</h2>
          <div className="space-y-3 max-w-2xl">
            {orders.map((o) => (
              <div key={o.id} data-testid={`client-order-${o.id}`} className="card-cocarde p-4">
                <div className="flex justify-between items-center">
                  <p className="font-bold cc-navy">{o.items?.map((i) => `${i.quantity}× ${i.pizza_name} (${i.box_name})`).join(", ")}</p>
                  <span className={`text-xs font-bold rounded-full px-3 py-1 ${o.payment_status === "paid" ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-500"}`}>
                    {o.payment_status === "paid" ? LABELS[o.status] : "Non payée"}
                  </span>
                </div>
                <p className="text-slate-500 text-sm mt-1">{o.pizzeria?.name} · {o.total} €</p>
              </div>
            ))}
            {orders.length === 0 && <div className="card-cocarde p-6 text-slate-400">Aucune commande. <Link to="/commander" className="text-cc-red font-bold">Commander</Link></div>}
          </div>
        </div>
      )}

      {tab === "candidacies" && (
        <div>
          <h2 className="font-display text-2xl cc-navy flex items-center gap-2 mb-4"><Trophy size={22} /> Mes candidatures</h2>
          <div className="space-y-3 max-w-2xl">
            {candidates.map((c) => (
              <div key={c.id} data-testid={`client-candidate-${c.id}`} className="card-cocarde p-4">
                <div className="flex justify-between items-center">
                  <p className="font-display text-xl cc-navy">{c.display_name}</p>
                  <span className={`text-xs font-bold rounded-full px-3 py-1 ${c.status === "approved" ? "bg-green-100 text-green-700" : c.status === "rejected" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}`}>
                    {c.status === "approved" ? "Validée" : c.status === "rejected" ? "Rejetée" : "En validation"}
                  </span>
                </div>
                <p className="text-slate-500 text-sm mt-1">{c.program}</p>
                <p className="text-slate-400 text-sm mt-1">{c.votes} votes</p>
                <div className="flex gap-2 mt-3">
                  <Link to={`/candidat/${c.slug}`} className="btn-navy text-sm py-2 px-4 inline-flex items-center gap-1"><Video size={14} /> Ma page</Link>
                  <button data-testid={`client-share-${c.id}`} onClick={() => copyLink(c.slug)} className="btn-cocarde text-sm py-2 px-4 inline-flex items-center gap-1"><Share2 size={14} /> Partager mon lien</button>
                </div>
              </div>
            ))}
            {candidates.length === 0 && <div className="card-cocarde p-6 text-slate-400">Pas encore candidat. <Link to="/concours" className="text-cc-red font-bold">Je me présente</Link></div>}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
